import { Modal } from "antd";
import styled from "styled-components";

export const RackIssueModal = styled(Modal)`
  .modalWrapper {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
  }

  svg.warnicon {
    font-size: 40px;
    color: var(--red);
  }

  p {
    font-size: 16px;
    text-align: center;
    font-weight: 600;
  }
`;

export const TOPOPageWrapper = styled.div`
  padding-bottom: 3em;
`;
